/*jshint esversion: 6 */
/*jshint strict: false */

import $ from 'jquery';
import * as d3 from 'd3';

import * as analysis from "./analysis";
import * as comparison from "./comparison";
import * as highestEarning from "./highest-earning";
import * as mostSuccessful from "./most-successful";
import * as highestRated from "./highest-rated";
import * as disagreements from "./disagreements";
import * as highestEarningBad from "./highest-earning-bad";
import * as gettingBetter from "./getting-better";
import * as gettingWorse from "./getting-worse";

let data = [];

let imageDir = '/content-projects/film-scores/images/';

function setupEvents(dataDir) {

    window.addEventListener("resize", setupGraphs);

    $('.compare').on('click', function () {
        if ($(window).width() >= 800) {
            $('.compare').toggleClass('active');
        }
    });

    $('body').on('click', function (e) {
        if ($(window).width() >= 800) {
            if (!$('.compare').has(e.target).length > 0) {
                if ($('.compare').hasClass('active')) {
                    $('.compare').removeClass('active');
                }
            }
        }
    });

    $(document).on('change', '.compare input', function () {

        let filmId = $(this).val();
        let $filmDiv = $('section.film[data-film-id="' + filmId + '"]');

        if ($(this).is(':checked')) {
            $filmDiv.slideDown();
        } else {
            $filmDiv.slideUp();
        }

        if( $('.compare input:checked').length > 0 ) {
            $('.toggleselect').text('Deselect All');
        } else {
            $('.toggleselect').text('Select All');
        }
    });

    $('.toggleselect').on('click', function () {
        if( $('.compare input:checked').length > 0 ) {
            $('.compare input:checked').prop('checked', false).trigger('change');
        } else {
            $('.compare input:not(:checked)').prop('checked', true).trigger('change');
        }
    });

    $('.reset').on('click', function () {
        $('.compare input:not(:checked)').prop('checked', true).trigger('change');
    });

    $('.show-compare').on('click', function () {
        $('.compare').addClass('active');
    });

    $('.compare .close').on('click', function () {
        $('.compare').removeClass('active');
    });

    $('.show-analysis').one('click', function(e) {
        e.preventDefault();
        analysis.init(dataDir);
        comparison.init(dataDir);
        highestEarning.init(dataDir);
        mostSuccessful.init(dataDir);
        highestRated.init(dataDir);
        disagreements.init(dataDir);
        highestEarningBad.init(dataDir);
        gettingBetter.init(dataDir);
        gettingWorse.init(dataDir);
        return false;
    });

    $('.show-analysis').on('click', function(e) {
        e.preventDefault();
        $('main.homepage').hide();
        $('main.analysis').show();
        return false;
    });
}

function setupGraph(svgElement, data) {

    let svg = d3.select(svgElement);

    svg.attr('height', 0);

    svg.selectAll("*").remove();

    svg.attr('height', $(svgElement).parents('table').outerHeight());

    let margin = {top: 0, right: 50, bottom: 0, left: 35};

    if ($(window).width() <= 800) {
        margin.right = 30;
        margin.left = 20;
    }

    let width = $(svgElement).width() - margin.left - margin.right,
        height = svg.attr("height") - margin.top - margin.bottom,
        g = svg.append("g").attr("transform", "translate(" + margin.left + "," + margin.top + ")");

    let xScale = d3.scaleLinear()
        .range([0, width])
        .domain([0, 10]);

    let yScale = d3.scaleLinear()
        .range([20, height + 20])
        .domain([0, data.length]);


    g.append("g")
        .attr("class", "axis")
        .attr("transform", "translate(0," + height + ")")
        .call(d3.axisBottom(xScale)
            .ticks(10)
            .tickSize(-height)
            .tickFormat("")
        );

    let gData = g.append("g")
        .attr('class', 'data');

    gData.selectAll('line.range')
        .data(data)
        .enter()
        .append('line')
        .attr('class', 'range')
        .attr('x1', function (d) {
            return (xScale(d.imdb) + xScale(d.rottentomato / 10)) / 2;
        })
        .attr('x2', function (d) {
            return (xScale(d.imdb) + xScale(d.rottentomato / 10)) / 2;
        })
        .attr('y1', function (d, i) {
            return getYPosition(svgElement, i);
        })
        .attr('y2', function (d, i) {
            return getYPosition(svgElement, i);
        });


    gData.selectAll("line.range")
        .data(data)
        .transition()
        .duration(1000)
        .attr('x1', function (d) {
            return xScale(d.imdb) > xScale(d.rottentomato / 10) ? xScale(d.rottentomato / 10) : xScale(d.imdb);
        })
        .attr('x2', function (d) {
            return xScale(d.imdb) > xScale(d.rottentomato / 10) ? xScale(d.imdb) : xScale(d.rottentomato / 10);
        });


    gData.selectAll("circle.imdb")
        .data(data)
        .enter()
        .append('circle')
        .attr('class', 'imdb')
        .attr('r', 4)
        .attr("cx", function (d) {
            return xScale(d.imdb);
        })
        .attr("cy", function (d, i) {
            return getYPosition(svgElement, i);
        })
        .attr("opacity", 0)
        .transition().delay(1000).duration(1000)
        .attr("opacity", 1);

    gData.selectAll("text.imdb")
        .data(data)
        .enter()
        .append('g')
        .attr('class', function (d) {
            return xScale(d.imdb) > xScale(d.rottentomato / 10) ? "text-start" : "text-end"
        })
        .append("text")
        .attr('class', 'imdb')
        .attr("x", function (d) {
            return xScale(d.imdb);
        })
        .attr("y", function (d, i) {
            return getYPosition(svgElement, i);
        })
        .attr("text-anchor", function (d) {
            return xScale(d.imdb) > xScale(d.rottentomato / 10) ? "start" : "end"
        })
        .text(function (d) {
            return d.imdb + '/10';
        })
        .attr("opacity", 0)
        .transition().delay(1000).duration(1000)
        .attr("opacity", 1);

    gData.selectAll("circle.rotten")
        .data(data)
        .enter()
        .append('circle')
        .attr('class', 'rotten')
        .attr('r', 4)
        .attr("cx", function (d) {
            return xScale(d.rottentomato / 10);
        })
        .attr("cy", function (d, i) {
            return getYPosition(svgElement, i);
        })
        .attr("opacity", 0)
        .transition().delay(1000).duration(1000)
        .attr("opacity", 1);

    gData.selectAll("text.rotten")
        .data(data)
        .enter()
        .append('g')
        .attr('class', function (d) {
            return xScale(d.imdb) > xScale(d.rottentomato / 10) ? "text-end" : "text-start"
        })
        .append("text")
        .attr('class', 'rotten')
        .attr("x", function (d) {
            return xScale(d.rottentomato / 10);
        })
        .attr("y", function (d, i) {
            return getYPosition(svgElement, i);
        })
        .attr("text-anchor", function (d) {
            return xScale(d.imdb) > xScale(d.rottentomato / 10) ? "end" : "start"
        })
        .text(function (d) {
            return d.rottentomato + '%';
        })
        .attr("opacity", 0)
        .transition().delay(1000).duration(1000)
        .attr("opacity", 1);

}

function getYPosition(svgElement, i) {
    var $table = $(svgElement).parents('table');
    return $table.find('tr:nth-of-type('+(i+1)+')').offset().top - $table.offset().top + ( $table.find('tr:nth-of-type('+(i+1)+')').outerHeight() / 2) - 8;
}


function populateTable() {

    let container = d3.select('div.data');

    let template = container.select(".template").remove().node();

    let i = 1;
    Object.keys(data).sort().forEach(function(franchise) {

        let highestImdb = Object.keys(data[franchise]).reduce(function (a, b) {
            return data[franchise][a]['imdb'] > data[franchise][b]['imdb'] ? a : b
        });
        let highestRotten = Object.keys(data[franchise]).reduce(function (a, b) {
            return data[franchise][a]['rottentomato'] > data[franchise][b]['rottentomato'] ? a : b
        });
        let highestRevenue = Object.keys(data[franchise]).reduce(function (a, b) {
            return data[franchise][a]['revenueMillions'] > data[franchise][b]['revenueMillions'] ? a : b
        });

        let div = container.append(function () {
            return template.cloneNode(true);
        });
        div.classed("template", false);
        div.attr('data-film-id', i);
        div.select('.title').text(franchise);

        let tbody = div.select('tbody');

        let tr = tbody.selectAll("tr")
            .data(data[franchise])
            .enter()
            .append("tr");

        tr.append("td").text(function (d, i) {
            return '#' + (i + 1);
        });

        let titleTd = tr.append("td").text(function (d) {
            return d.title;
        });

        titleTd.filter(function (d, i) {
            return i == highestImdb;
        })
            .append('img').attr('src', imageDir + 'star-yellow.svg').attr('class', 'star');

        titleTd.filter(function (d, i) {
            return i == highestRotten;
        })
            .append('img').attr('src', imageDir + 'star-red.svg').attr('class', 'star');

        titleTd.filter(function (d, i) {
            return i == highestRevenue;
        })
            .append('img').attr('src', imageDir + 'star-blue.svg').attr('class', 'star');


        tr.append("td").text(function (d) {
            return d.year;
        });

        tr.filter(function (d, i) {
            return i == 0;
        })
            .append("td")
            .attr('rowspan', data[franchise].length)
            .attr('class', 'graph')
            .append('svg')
            .attr('xmlns', 'http://www.w3.org/2000/svg')
            .attr('height', 0);

        tr.append("td").text(function (d) {
            if( d.revenueMillions == 0 ) {
                return "Unknown";
            } else {
                return "$" + d.revenueMillions + " M";
            }
        });

        i++;
    });

}

function populateDropdown() {

    let ul = d3.select('.compare ul');

    let template = ul.select('li.template').remove().node();

    let i = 1;
    Object.keys(data).sort().forEach(function(franchise) {

        let li = ul.append(function () {
            return template.cloneNode(true);
        })
            .classed('template', false);

        li.select('input')
            .attr('id', 'film[' + i + ']')
            .attr('value', i)
            .attr('checked', true);

        li.select('label')
            .attr('for', 'film[' + i + ']');

        li.select('span')
            .text(franchise);

        i++
    });

    document.querySelector('.compare').style.minWidth = (document.querySelector('.compare ul').offsetWidth + 30) + 'px';
}

function loadData(dataDir) {

    d3.csv(dataDir + "films.csv", function (csvData) {
        csvData.forEach(function (d) {
            d.year = +d.year;
            d.imdb = +d.imdb;
            d.rottentomato = +d.rottentomato.replace('%', '');

            d.revenueText = d.revenue;
            d.revenue = d.revenue.replace(/[$,£]+/g, "");
            d.revenueMillions = parseInt(parseInt(d.revenue) / 1000000);

            if (!data.hasOwnProperty(d.franchise)) {
                data[d.franchise] = [];
            }

            data[d.franchise].push(d);
        });

        populateTable();
        populateDropdown();
        setupGraphs();
    });
}

function setupGraphs() {

    let i = 1;
    Object.keys(data).sort().forEach(function(franchise) {
        setupGraph('.film[data-film-id="' + i + '"] .graph svg', data[franchise]);
        i++
    });

}

function init(dataDir) {
    loadData(dataDir);
    setupEvents(dataDir);
}

export {init}


// WEBPACK FOOTER //
// ./homepage.js